import { isStringArray } from "graphql/helpers/queryHelpers";
import { RegionType } from "./regionType";

export const LOAD_VIEW_ENABLED = "load_view_enabled";
// Opts a team into uploading many scenarios from CSVs at once. Flipped in
// Retool on teams.feature_flags.
export const IQ_BULK_CSV_UPLOAD = "in_queue_bulk_csv_upload";

export const TEAM_FEATURE_FLAG_TYPES = [
    LOAD_VIEW_ENABLED,
    IQ_BULK_CSV_UPLOAD
] as const;
export type TeamFeatureFlagType =
    | (typeof TEAM_FEATURE_FLAG_TYPES)[number]
    | string;

// Helper functions for dynamic feature flags
export const getLoadOnlyFlag = (region: RegionType): TeamFeatureFlagType =>
    `load_only:${region}`;
export const getLoadAndGenFlag = (region: RegionType): TeamFeatureFlagType =>
    `load_and_gen:${region}`;
export const getAdvancedStudiesFlag = (
    region: RegionType
): TeamFeatureFlagType => `advanced_studies:${region}`;

// Local studies (user scopes) access is granted per region, e.g.
// "local_studies:MISO".
export const LOCAL_STUDIES_FLAG_PREFIX = "local_studies:";
export const getLocalStudiesFlag = (region: RegionType): TeamFeatureFlagType =>
    `${LOCAL_STUDIES_FLAG_PREFIX}${region}`;

export const isKnownTeamFeatureFlagType = (
    type: string
): type is TeamFeatureFlagType => {
    // Check for static flags
    const staticFlags = TEAM_FEATURE_FLAG_TYPES as readonly string[];
    if (staticFlags.includes(type)) {
        return true;
    }

    // Check for dynamic flags with pattern load_only:REGION, load_and_gen:REGION,
    // advanced_studies:REGION, or local_studies:REGION
    if (
        type.startsWith("load_only:") ||
        type.startsWith("load_and_gen:") ||
        type.startsWith("advanced_studies:") ||
        type.startsWith(LOCAL_STUDIES_FLAG_PREFIX)
    ) {
        return true;
    }

    return false;
};

export const convertToTeamFeatureFlagType = (
    string: string
): TeamFeatureFlagType => {
    if (isKnownTeamFeatureFlagType(string)) {
        return string;
    }

    throw new Error("Unexpected team feature flag");
};

export const convertToTeamFeatureFlagTypeList = (
    hasuraObject: unknown
): ReadonlyArray<TeamFeatureFlagType> => {
    if (!isStringArray(hasuraObject)) {
        throw new Error("Expected array of strings");
    }

    const listOfStrings: string[] = hasuraObject;
    const validFeatureFlags: TeamFeatureFlagType[] = listOfStrings
        .filter(isKnownTeamFeatureFlagType)
        .map(convertToTeamFeatureFlagType);

    return validFeatureFlags;
};
